export const environment = {
  production: true,
  API: 'https://api-isc.capi.services',
  MEDIA_URL: 'https://d1z30843aicveo.cloudfront.net/'
};




// WEBPACK FOOTER //
// /app/src/environments/environment.ts